// extracted by mini-css-extract-plugin
export default {"buttonBox":"styles_buttonBox__7gtS6","scroll":"styles_scroll__kDLsb"};